/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip, TextField, InputAdornment } from '@mui/material'
import React, { useState } from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Data from './Data';
import PolicyPopup from './PolicyPopup';
import HolidayDataTable from './HolidayDataTable';
import AddHolidayPop from './AddHolidayPop';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import TimeBalanceData from './TimeBalanceData';
import ImportPop from './ImportPop';
import NoDataFound from './NoDataFound';
const TimeOffPage = () => {

    const [activeTab, setActiveTab] = useState('default');

    const [openPolicyPop, setOpenPolicyPop] = React.useState(false);

    const handleClickPolicyPop = () => {
        setOpenPolicyPop(true);
    };
    const handleClosePolicyPop = () => {
        setOpenPolicyPop(false);
    };


    const [openHolidayPop, setHolidayPop] = React.useState(false);

    const handleClickHolidayPop = () => {
        setHolidayPop(true);
    };
    const handleCloseHolidayPop = () => {
        setHolidayPop(false);
    };

    const [openImportDataPop, setImportDataPop] = React.useState(false);

    const handleClickImportDataPop = () => {
        setImportDataPop(true);
    };
    const handleCloseImportDataPop = () => {
        setImportDataPop(false);
    };

    const tabBtnStyle = {
        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
    }
    return (
        <>
            <Box sx={{
                overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                maxWidth: '100%',
            }}>
                {/* Tabs */}
                <Box display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}>
                    <Button onClick={() => setActiveTab('default')} variant="contained" sx={{
                        ...tabBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'default' ? '#0076FE' : '#fff', color: activeTab === 'default' ? '#fff' : '#64748B', border: activeTab === 'default' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Time off policies
                    </Button>
                    <Button onClick={() => setActiveTab('complete')} variant="contained" sx={{
                        ...tabBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'complete' ? '#0076FE' : '#fff',
                        color: activeTab === 'complete' ? '#fff' : '#64748B', border: activeTab === 'complete' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Holidays
                    </Button>

                    <Button onClick={() => setActiveTab('edittab')} variant="contained" sx={{
                        ...tabBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'edittab' ? '#0076FE' : '#fff',
                        color: activeTab === 'edittab' ? '#fff' : '#64748B', border: activeTab === 'edittab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Time off balances
                    </Button>
                </Box>
                {/* Tab Panel Content */}
            </Box>

            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>

                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="default">
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                    Time off policies
                                    <Tooltip title="This allows managers to set up policies." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Configure automated time off accrual rules</Typography>
                            </Box>
                            <Box>
                                <Button onClick={handleClickPolicyPop} variant="contained" sx={{    ...tabBtnStyle, boxShadow: 'none',  width: '120px', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                                    + Add Policy</Button>
                            </Box>
                        </Box>
                        <Data />
                        <NoDataFound />
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="complete">
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                        <Box>
                            <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                Holidays
                                <Tooltip title="This allows managers to set up policies." arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Configure holiday schedules for leave</Typography>
                        </Box>
                        <Box>
                            <Button onClick={handleClickHolidayPop} variant="contained" sx={{ boxShadow: 'none', width: '130px', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                                + Add holiday</Button>
                        </Box>
                    </Box>
                    <HolidayDataTable />
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="edittab">
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <Box>
                            <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                Time off balances
                                <Tooltip title="This allows managers to set up policies." arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Configure team members' leave balances</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <Box>
                            <TextField
                                placeholder="Search Member"
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    sx: { borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: '250px', fontFamily: 'Manrope' },
                                }}
                            />
                        </Box>
                        <Box>
                            <Button variant="contained" sx={{ boxShadow: 'none', width: {xl: '130px' , lg: '130px' , md: '130px' , sm: '110px' , xs: '130px'}, fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #ddd', background: '#fff', color: '#0076FE', textTransform: 'capitalize', marginRight: '10px' }} > <FileDownloadOutlinedIcon color='#0076FE' />  Export</Button>
                            <Button onClick={handleClickImportDataPop} variant="contained" sx={{ boxShadow: 'none', width: {xl: '130px' , lg: '130px' , md: '130px' , sm: '110px' , xs: '130px'}, fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >Import</Button>
                        </Box>
                    </Box>
                    <TimeBalanceData />
                </CustomTabPanel>
            </Box>
            <AddHolidayPop openHolidayPop={openHolidayPop} handleCloseHolidayPop={handleCloseHolidayPop} />
            <PolicyPopup openPolicyPop={openPolicyPop} handleClosePolicyPop={handleClosePolicyPop} />
            <ImportPop openImportDataPop={openImportDataPop} handleCloseImportDataPop={handleCloseImportDataPop} />
        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box sx={{ padding: { xl: '16px 5px', lg: '15px 0', md: '15px 0', sm: '15px  0', sx: '15px 0' } }}>{children}</Box>;
};


export default TimeOffPage
